var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layout-header" }, [
    _c(
      "div",
      { staticClass: "layout-title" },
      [
        _vm._v(" " + _vm._s(_vm.headerTitle) + " "),
        _vm._t("header-title-action"),
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "layout-header-actions" },
      [_vm._t("header-actions")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }